export const t = { "en": { "breezeSetupProspectingAgent": { "setupPrompt": "Help me set up my prospecting agent." } } };
export const d = [];